import { Link, useLocation } from "react-router-dom";
import { ChevronRight, Home } from "lucide-react";

const routeNames = {
  "/": "Dashboard",
  "/members": "All Members",
  "/members/new": "Add Member",
  "/members/overview": "Overview",
  "/members/expired": "Expired",
  "/memberships": "All Memberships",
  "/memberships/overview": "Overview",
  "/packages": "Packages",
  "/branches": "Branches",
  "/staff": "Staff",
  "/attendance": "Attendance",
  "/subscription": "Subscription",
  "/settings": "Settings",
};

export function Breadcrumbs() {
  const location = useLocation();
  const pathnames = location.pathname.split("/").filter((x) => x);

  // Don't show breadcrumbs on dashboard
  if (location.pathname === "/") return null;

  const breadcrumbs = [];
  let currentPath = "";

  pathnames.forEach((segment, index) => {
    currentPath += `/${segment}`;

    // Check if it's an ID (UUID pattern)
    const isId = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i.test(segment);

    if (isId) {
      breadcrumbs.push({
        path: currentPath,
        name: "Details",
        isLast: index === pathnames.length - 1,
      });
    } else {
      const name = routeNames[currentPath] || segment.charAt(0).toUpperCase() + segment.slice(1);
      breadcrumbs.push({
        path: currentPath,
        name,
        isLast: index === pathnames.length - 1,
      });
    }
  });

  return (
    <nav className=" items-center gap-1.5 text-sm mb-4 hidden md:flex" aria-label="Breadcrumb">
      <Link
        to="/"
        className="text-muted-foreground hover:text-foreground transition-colors flex items-center gap-1"
      >
        <Home className="h-3.5 w-3.5" />
      </Link>
      {breadcrumbs.map((crumb, index) => (
        <div key={crumb.path} className="flex items-center gap-1.5">
          <ChevronRight className="h-3.5 w-3.5 text-muted-foreground/50" />
          {crumb.isLast ? (
            <span className="text-foreground font-medium">{crumb.name}</span>
          ) : (
            <Link
              to={crumb.path}
              className="text-muted-foreground hover:text-foreground transition-colors"
            >
              {crumb.name}
            </Link>
          )}
        </div>
      ))}
    </nav>
  );
}
